import React from 'react';
import { Navigate } from 'react-router-dom';

export function ProfileRedirect() {
  const savedMode = localStorage.getItem('activeDashboardMode');
  const isWP = readIsWorkingProfessional();
  const target =
    savedMode === 'employee'
      ? '/referral-dashboard/profile'
      : isWP
        ? '/referral-dashboard/jobseeker-dashboard/profile'
        : '/jobseeker-dashboard/profile';
  return <Navigate to={target} replace />;
}

export function BookingsRedirect() {
  const savedMode = localStorage.getItem('activeDashboardMode');
  const isWP = readIsWorkingProfessional();
  const target =
    savedMode === 'employee'
      ? '/referral-dashboard/my-sessions'
      : isWP
        ? '/referral-dashboard/jobseeker-dashboard/my-sessions'
        : '/jobseeker-dashboard/my-sessions';
  return <Navigate to={target} replace />;
}

function readIsWorkingProfessional(): boolean {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return false;
    const user = JSON.parse(userStr);
    return user.userType === 'working_professional' || user.role === 'referrer';
  } catch {
    return false;
  }
}

export function NetworkRedirect() {
  const target = readIsWorkingProfessional() ? '/referral-dashboard' : '/jobseeker-dashboard';
  return <Navigate to={target} replace />;
}

export function NetworkCalendarRedirect() {
  const target = readIsWorkingProfessional()
    ? '/referral-dashboard/calendar'
    : '/jobseeker-dashboard/my-sessions';
  return <Navigate to={target} replace />;
}

export function NetworkAnalyticsRedirect() {
  const target = readIsWorkingProfessional()
    ? '/referral-dashboard/analytics'
    : '/jobseeker-dashboard';
  return <Navigate to={target} replace />;
}
